import { getDistance, getLength } from 'ol/sphere';
import { toLonLat } from 'ol/proj';

// export function IsGeoServerAvailable(timeoutMs, baseGeoserverURL) {
//   let timeout = new Promise((resolve, reject) => {
//     let id = setTimeout(() => {
//       clearTimeout(id);
//       reject('Request timed out');
//     }, timeoutMs);
//   });

//   let fetchPromise = fetch(baseGeoserverURL + 'wfs?service=wfs&version=2.0.0&request=GetCapabilities');

//   Promise.race([fetchPromise, timeout])
//     .then((response) => {
//       if (response.ok) {
//         console.log('GeoServer is available');
//         return true;
//       } else {
//         console.log('GeoServer is not available');
//         return false;
//       }
//     })
//     .catch((error) => {
//       console.log('Error occurred while contacting GeoServer:', error);
//       return false;
//     });
// }

// export function IsGeoServerAvailable(timeoutMs, baseGeoserverURL) {
//   let timeout = new Promise((resolve, reject) => {
//     let id = setTimeout(() => {
//       clearTimeout(id);
//       reject('Request timed out');
//     }, timeoutMs);
//   });

//   let fetchPromise = fetch(baseGeoserverURL + 'wfs?service=wfs&version=2.0.0&request=GetCapabilities');

//   return Promise.race([fetchPromise, timeout])
//     .then((response) => {
//       if (response.ok) {
//         return true;
//       } else {
//         return false;
//       }
//     })
//     .catch((error) => {
//       return false;
//     });
// }

// export async function IsGeoServerAvailable(timeoutMs, baseGeoserverURL) {
//   return new Promise((resolve, reject) => {
//     let timeoutId = setTimeout(() => {
//       reject(new Error('Request timed out'));
//     }, timeoutMs);

//     fetch(baseGeoserverURL + 'wfs?service=wfs&version=2.0.0&request=GetCapabilities')
//       .then((response) => {
//         clearTimeout(timeoutId);
//         if (response.ok) {
//           resolve(true);
//         } else {
//           resolve(false);
//         }
//       })
//       .catch((error) => {
//         console.log('IsGeoServerAvailable: inside catch');
//         clearTimeout(timeoutId);
//         resolve(false);
//       });
//   });
// }

export async function IsGeoServerAvailableOld() {
  let url = 'https://br-geoportal.itu.int/ITU-R/BR-Geo/' + 'wfs?service=wfs&version=2.0.0&request=GetCapabilities';
  let isAvailable = false;
  try {
    const response = await fetch(url);
    if (response.ok) {
      isAvailable = true;
      // console.log('Server is available');
    } else {
      console.log('Server is not available. Status: ' + response.status);
    }
  } catch (error) {
    console.log('Server is not available. ' + error);
  }
  return isAvailable;
}

function timeout(ms, promise) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error('timeout'));
    }, ms);

    promise.then(resolve, reject);
  });
}

export async function IsGeoServerAvailable2(timer) {
  let url = 'https://br-geoportal.itu.int/ITU-R/BR-Geo/' + 'wfs?service=wfs&version=2.0.0&request=GetCapabilities';
  let isAvailable = false;
  try {
    const response = await timeout(timer, fetch(url));
    if (response.ok) {
      isAvailable = true;
      // console.log('Server is available');
    } else {
     // console.log('Server is not available. Status: ' + response.status);
    }
  } catch (error) {
   // console.log('Server is not available. ' + error);
  }

  return isAvailable;
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export function formatAzimutOld(lineCoordinates) {
  let azimuth = '';
  if (!isEmpty(lineCoordinates.start) && !isEmpty(lineCoordinates.end)) {
    azimuth =
      (Math.atan2(
        lineCoordinates.end[0] - lineCoordinates.start[0],
        lineCoordinates.end[1] - lineCoordinates.start[1]
      ) *
        180) /
      Math.PI;
    if (azimuth < 0) {
      azimuth = azimuth + 360;
    }
    azimuth = azimuth.toFixed(1);
  }

  return azimuth;
}

export function formatAzimuth(line) {
  let azimuth = '';
  const toRadians = Math.PI / 180;
  const toDegrees = 180 / Math.PI;

  if (!isEmpty(line.start) && !isEmpty(line.end)) {
    const [long1, lat1] = line.start.map((coord) => coord * toRadians);
    const [long2, lat2] = line.end.map((coord) => coord * toRadians);
    const dLon = long2 - long1;
    const y = Math.sin(dLon) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
    azimuth = Math.atan2(y, x) * toDegrees;
    azimuth = (azimuth + 360) % 360;
    azimuth = azimuth.toFixed(1);
  }

  return azimuth;
}

export const formatAzimuthFormMeters = (line) => {
  const toDegrees = (angle) => angle * (180 / Math.PI);
  let azimuth = '';
  if (line.start.length > 0 && line.end.length > 0) {
    const dx = line.end[0] - line.start[0];
    const dy = line.end[1] - line.start[1];
    azimuth = Math.atan2(dy, dx);
    azimuth = toDegrees(azimuth);
    azimuth = (azimuth + 360) % 360;
    azimuth = azimuth.toFixed(1);
  }
  return azimuth;
};

export function formatLength(line) {
  var length = getLength(line);
  var output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'm';
  }
  return output;
}

export function filterObjectByProperties(obj, properties) {
  let result = Object.keys(obj)
    .filter((key) => properties.includes(key))
    .reduce((newObj, key) => {
      newObj[key] = obj[key];
      return newObj;
    }, {});

  return Object.values(result);
}
export function filterLayers(obj, properties) {
  let names = [];
  let deletable = [];
  let hasDeleteBtn = 'hasDeleteBtn';
  properties.forEach((p) => {
    if (typeof p === 'object') {
      if (p.hasOwnProperty('name')) {
        let name = p['name'];
        names.push(name);
        if (p.hasOwnProperty(hasDeleteBtn)) {
          if (p[hasDeleteBtn] === true) {
            deletable.push(name);
          }
        }
      }
    } else if (typeof p === 'string') {
      names.push(p);
    }
  });
  // let result = Object.keys(obj)
  //   .filter((key) => names.includes(key))
  //   .reduce((newObj, key) => {
  //     obj[key].set(hasDeleteBtn, false);
  //     newObj[key] = obj[key];
  //     return newObj;
  //   }, {});
  let result = {};
  names.forEach((name) => {
    let hide = properties.find((x) => x.name == name)?.hide; //if not defined will be visible
    if (hide) obj[name].setVisible(false);

    let opacity = properties.find((x) => x.name == name)?.opacity; //if not defined will be visible
    if ((opacity || opacity == 0) && opacity >= 0 && opacity <= 1) obj[name].setOpacity(opacity);

    obj[name].set(hasDeleteBtn, false);
    result[name] = obj[name];
  });

  if (deletable.length > 0) {
    deletable.forEach((elt) => {
      result[elt].set(hasDeleteBtn, true);
    });
  }

  result = Object.values(result);

  return result;
}
export function calculateBearing(coord1, coord2) {
  // Convert coordinates to radians
  var lat1 = (toLonLat(coord1)[1] * Math.PI) / 180.0;
  var lon1 = (toLonLat(coord1)[0] * Math.PI) / 180.0;
  var lat2 = (toLonLat(coord2)[1] * Math.PI) / 180.0;
  var lon2 = (toLonLat(coord2)[0] * Math.PI) / 180.0;

  // Calculate the difference in longitudes
  var dLon = lon2 - lon1;

  // Calculate the bearing
  var y = Math.sin(dLon) * Math.cos(lat2);
  var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
  var brng = Math.atan2(y, x);

  // Convert the bearing to degrees and normalize it to 0 - 360
  brng = ((brng * 180.0) / Math.PI + 360) % 360;

  return brng;
}

export function createChkIndexes(checkboxes) {
  let indexes = checkboxes.map((x) => x.index);
  indexes = indexes.filter((element) => element !== null && element !== undefined).sort();
  let indexMax = indexes.length > 0 ? Math.max(...indexes) : -1;

  let index = indexMax;
  checkboxes.forEach((chk) => {
    if (chk.index == null) {
      index++;
      chk.index = index;
    }
  });
}

function ddToDMS(deg, isLatitude) {
  var absolute = Math.abs(deg);
  var degrees = Math.floor(absolute);
  var minutesNotTruncated = (absolute - degrees) * 60;
  var minutes = Math.floor(minutesNotTruncated);
  var seconds = Math.floor((minutesNotTruncated - minutes) * 60); // Round seconds

  var direction = isLatitude ? (deg >= 0 ? 'N' : 'S') : deg >= 0 ? 'E' : 'W';

  degrees = padLeft(degrees, isLatitude ? 2 : 3);
  minutes = padLeft(minutes, 2);
  seconds = padLeft(seconds, 2);

  return degrees + '°' + minutes + "'" + seconds + '"' + direction;
}

export function parseDMS(dms) {
  // Split the string into its components
  var parts = dms.split(' ');

  // Parse the components
  var latDeg = parseInt(parts[0]);
  var latMin = parseInt(parts[1]);
  var latSec = parseFloat(parts[2]);
  var latDir = parts[3];

  var lonDeg = parseInt(parts[4]);
  var lonMin = parseInt(parts[5]);
  var lonSec = parseFloat(parts[6]);
  var lonDir = parts[7];
  let result = {
    long: {
      d: lonDeg,
      m: lonMin,
      s: lonSec,
      dir: lonDir,
    },
    lat: {
      d: latDeg,
      m: latMin,
      s: latSec,
      dir: latDir,
    },
  };
  return result;
}

export function removeExtension(filename) {
  if (filename) {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex !== -1 && lastDotIndex > 0) {
      return filename.substring(0, lastDotIndex);
    }
  }
  return filename;
}

export function convertJsonToContours(geojsonStr) {
  const geojsonObj = JSON.parse(geojsonStr);

  let contours = [];

  geojsonObj.features.forEach((feature) => {
    if (feature.geometry.type === 'Polygon') {
      // For Polygon, push the coordinates directly
      contours.push(feature.geometry.coordinates);
    } else if (feature.geometry.type === 'MultiPolygon') {
      // For MultiPolygon, push each polygon's coordinates separately
      feature.geometry.coordinates.forEach((polygon) => {
        contours.push(polygon);
      });
    }
  });

  //console.log(contours);
  return contours;
}
